export default "__VITE_ASSET__CV7YlqeQ__"